import { render, staticRenderFns } from "./MungBeanAllocateBatchDetailDialog.vue?vue&type=template&id=6ac45844&scoped=true&lang=pug&"
import script from "./MungBeanAllocateBatchDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./MungBeanAllocateBatchDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MungBeanAllocateBatchDetailDialog.vue?vue&type=style&index=0&id=6ac45844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac45844",
  null
  
)

export default component.exports